<div class="page-wrapper">
    <div class="mid-component-section custom-scroll-bar">

        <div class="logo">
            <img src="assets/images/icpc-logo.png" width="75px" alt="logo">
        </div>

       <div class="mid-heading-top" *ngIf="category == 'ACTIVATION' ">
            Welcome to
        </div>

        <div class="mid-heading-bottom">
             Directorate of Intelligence
        </div>

        <div class="mid-heading-top mt-2" *ngIf="category == 'PASSWORD' ">
            Reset Your Password
        </div>

        <div class="mid-heading-low">
            Enter Your New Password
        </div>

        <form  #verifyForm="ngForm" class="form-wrapper" [formGroup]="loginForm">
            <div>
                <mat-form-field floatLabel="never" style="width: 100%; font-size: 14px;" appearance="outline">
                    <input  matInput [value]="email" [disabled]="true">
                </mat-form-field>
            </div>

            <div>
                <mat-form-field floatLabel="never" style="width: 100%; font-size: 14px;" appearance="outline">
                    <input  matInput placeholder="Password" [type]="hide ? 'password' : 'text'" formControlName="password">
                    <mat-icon style="color: #778; cursor: pointer;" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </mat-form-field>
            </div>

            <div>
                <mat-form-field floatLabel="never" style="width: 100%; font-size: 14px;" appearance="outline">
                    <input [type]="hide ? 'password' : 'text'" matInput placeholder="Confirm password" formControlName="confirmpassword">
                    <mat-icon style="color: #778; cursor: pointer;" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>

                </mat-form-field>
            </div>

            <div class="error-style" *ngIf="errorMsg">{{errorMsg}}</div>

            <button mat-flat-button [disabled] = "verifyForm.invalid || loading" color="red" class="signIn-button" (click)="signIn()">
                <p class="button_text" *ngIf = "!(loading)" > Create </p>

                <img class = "button_loader" src="assets/images/Infinity-1.8s-200px.svg" alt="" *ngIf="loading">
            </button>

        </form>

        <div class="bottom">
            Powered by
            <a target="_blank" href="https://comsoftltd.com/">
                <img src="assets/images/comsoftlogo.png" alt="comsoftlogo" style="width: 100px;">
            </a>
        </div>
    </div>

    <div class="footer">&copy; {{currentDate}}. All Rights Reserved. Economic and Financial Crimes Commission (EFCC).</div>
</div>



